import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import "bootstrap/dist/css/bootstrap.min.css";
import { Tooltip } from "bootstrap";

const letterColors = {
  H: "text-primary",
  W: "text-success",
  J: "text-danger",
  C: "text-warning",
  S: "text-info",
  T: "text-secondary",
  O: "text-dark",
};

// Simple position validator: must be non-empty string with letters and spaces only
const isValidPosition = (pos) => {
  return typeof pos === "string" && pos.trim() !== "" && /^[A-Za-z\s]+$/.test(pos);
};

const Position = ({ position }) => {
  const tooltipRef = useRef(null);
  const tooltipInstance = useRef(null);

useEffect(() => {
  if (tooltipRef?.current) {
    if (tooltipInstance?.current) {
      try {
        tooltipInstance.current.dispose();
      } catch (e) {
        // Swallow errors during dispose (like the jQuery null error)
        // Optionally log if needed: console.warn('Tooltip dispose error:', e);
      }
    }

    tooltipInstance.current = new Tooltip(tooltipRef.current);

    return () => {
      if (tooltipInstance?.current) {
        try {
          tooltipInstance.current.dispose();
        } catch (e) {
          // Swallow dispose errors here too
        }
      }
    };
  }
}, [position]);

  if (!isValidPosition(position)) {
    // fallback UI when position is invalid or empty
    return <span className="ms-2 text-muted">-</span>;
  }

  const initials = position
    .split(" ")
    .map((word) => word[0].toUpperCase())
    .join("");

  return (
    <span
      ref={tooltipRef}
      className="ms-2"
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      title={position}
      style={{ cursor: "pointer" }}
    >
      (
      {initials.split("").map((char, idx) => (
        <span
          key={idx}
          className={`fw-bold ${letterColors[char] || "text-muted"}`}
          // style={{ padding: "0 2px" }}
        >
          {char}
        </span>
      ))}
      )
    </span>
  );
};

Position.propTypes = {
  position: PropTypes.string.isRequired,
};

export default Position;
